import React, { useState, useEffect } from 'react'

const ExpirationCountdown = ({ expirationDate, className = '' }) => {
  const [timeLeft, setTimeLeft] = useState('')
  const [isExpired, setIsExpired] = useState(false)

  useEffect(() => {
    if (!expirationDate) return

    const updateCountdown = () => {
      const now = new Date()
      const expiration = new Date(expirationDate)
      const diff = expiration.getTime() - now.getTime()

      if (diff <= 0) {
        setTimeLeft('Expirada')
        setIsExpired(true)
        return
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))

      if (days > 0) {
        setTimeLeft(`${days}d ${hours}h ${minutes}m restantes`)
      } else if (hours > 0) {
        setTimeLeft(`${hours}h ${minutes}m restantes`)
      } else {
        setTimeLeft(`${minutes}m restantes`)
      }

      setIsExpired(false)
    }

    updateCountdown()
    const interval = setInterval(updateCountdown, 60000) // Update every minute

    return () => clearInterval(interval)
  }, [expirationDate])

  if (!expirationDate) return null

  const getColorClass = () => {
    if (isExpired) return 'text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/30 border-red-200 dark:border-red-700'
    
    const now = new Date()
    const expiration = new Date(expirationDate)
    const diff = expiration.getTime() - now.getTime()
    const hoursLeft = diff / (1000 * 60 * 60)

    if (hoursLeft <= 2) return 'text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/30 border-red-200 dark:border-red-700'
    if (hoursLeft <= 24) return 'text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-900/30 border-orange-200 dark:border-orange-700'
    return 'text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30 border-blue-200 dark:border-blue-700'
  }

  return (
    <div className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg border font-medium text-sm transition-colors ${getColorClass()} ${className}`}>
      <span className="text-lg">⏰</span>
      <span>{timeLeft}</span>
    </div>
  )
}

export default ExpirationCountdown
